<template>
  <div class="thousand_layout" v-loading="loading">
    <div class="bids_tabs">
      <div @click="BidsTabs(0)" :class="bidsTabs==0?'on':''">{{ $t('base.bids') }}</div>
      <div @click="BidsTabs(1)" :class="bidsTabs==1?'on':''">{{ $t('base.offers') }}</div>
      <div @click="BidsTabs(2)" :class="bidsTabs==2?'on':''">{{ $t('base.auctionEnded') }}</div>
    </div>
    <div class="right_box" v-if="bidsTabs==0">
      <div class="flex_layout_bids">
        <div class="bids_radio_box">
          <!--   Show:
          <el-radio v-model="bids" label="1">Not hidden</el-radio>
          <el-radio v-model="bids" label="2">All</el-radio> -->
        </div>
        <div class="watch_sort_status">
          <div>
            {{ $t('colon.sort') }}
            <el-select class="all_bids all_sort" v-model="Sort" @change="bidsSort">
              <el-option v-for="(item,index) in bids_sort" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="right_box" v-if="bidsTabs==1">
      <div class="flex_layout_bids">
        <div class="bids_radio_box">
          <!--   Show:
          <el-radio v-model="bids" label="1">Not hidden</el-radio>
          <el-radio v-model="bids" label="2">All</el-radio> -->
        </div>
        <div class="watch_sort_status">
          <div>
            {{ $t('colon.status') }}
            <el-select class="all_bids offer" v-model="oStatus" @change="offerStatus">
              <el-option v-for="(item,index) in offer_Status" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div>
            {{ $t('colon.sort') }}
            <el-select class="all_bids all_sort" v-model="Sort" @change="bidsSort">
              <el-option v-for="(item,index) in offer_sort" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
      <watch-list class="" :list="list" :type="listType" @updatedWatch="updatedWatch" v-if="!nofind"/>
      <!-- <watch-check class="" :list="list" :type="listType" v-if="bidsTabs!=0"/> -->
      <list-pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!nofind"/>
      <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
      <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else/>
  </div>
</template>
<script>
import WatchList from '@/components/list/watch'
// import WatchCheck from '@/components/list/watchcheck'
import ListPagination from '@/components/listpagination'
import NOTN from "@/components/notnull";
import FZF from "@/components/404.vue";

export default {
  name: 'tabslist',
  components: { WatchList, ListPagination, FZF, NOTN },
  data() {
    return {
      loading:false,
      listType: "bids",
      list: "",
      pi: 1,
      ps: 60,
      TotalCount: 0,
      onsale: 1,
      isStatus: false,
      isSort: false,
      bids: '1',
      bidsTabs: 0,
      oStatus: 'null',
      Sort: "1",
      offer_Status: this.$enumInfo.offer_status,
      bids_sort: this.$enumInfo.bids_sort,
      offer_sort: this.$enumInfo.offer_sort,
      sum:'',
      nofind:false,
      resultTpye: '',
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    this.getBids();
  },
  mounted() {
    //this.getOffer()
  },
  methods: {
    // 获取竞拍列表
    /**
     * 获取用户竞拍列表数据
     * @description 根据用户信息和筛选条件请求竞拍列表数据,包含分页功能
     * @method getBids
     * @returns {Promise} 返回竞拍列表数据请求的Promise对象
     * @property {Array} list - 竞拍列表数据
     * @property {Number} TotalCount - 总数据条数
     * @property {Boolean} nofind - 是否有数据标识
     * @property {Boolean} loading - 加载状态
     * @property {Number} resultTpye - 请求结果类型
     */
    getBids() {
      let that = this;
      that.loading=true;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, onsale:that.onsale, sortType: that.Sort, pageIndex: that.pi, pageSize: that.ps }
      this.$get(this.$interface.BuyerAuction, data).then(res => {
        if (res.result != 0) {
          //console.log(res)
          that.list = JSON.parse(JSON.stringify(res.data))
          that.TotalCount = res.count
          if(res.count==0){
            this.nofind=true
          }else{
            this.nofind=false
          }
        }else{
          this.nofind=true
        }
        that.loading=false;
        this.resultTpye = res.result
      })
    },
    // 获取一口价列表
    /**
     * 获取买家议价列表数据
     * @description 通过用户信息和筛选条件请求买家议价列表,并更新列表数据状态
     * @returns {Promise} 返回请求结果的Promise对象
     * @private
     * 
     * 参数说明:
     * - operator_id: 操作用户ID
     * - memberid: 会员ID
     * - token: 用户令牌
     * - onsale: 在售状态
     * - status: 议价状态
     * - sortType: 排序方式
     * - pageIndex: 当前页码
     * - pageSize: 每页数量
     */
    getOffer() {
      let that = this;
      that.loading=true;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, onsale: that.onsale, status: that.oStatus, sortType: that.Sort, pageIndex: that.pi, pageSize: that.ps }
      this.$get(this.$interface.BuyerBargain, data).then(res => {
        if (res.result != 0) {
          that.list=""
          that.list = JSON.parse(JSON.stringify(res.data))
          that.TotalCount = res.count
          if(res.count==0){
            this.nofind=true
          }else{
            this.nofind=false
          }
        }else{
          this.nofind=false
        }
        that.loading=false;
        this.resultTpye = res.result
      })
    },
    /**
     * 处理标签页切换的方法
     * @param {number} val - 标签页索引值：0-竞拍中，1-报价中，2-已结束
     * @description 根据不同标签页切换，重置分页参数并获取相应列表数据：
     * - 0: 获取竞拍中的列表
     * - 1: 获取报价中的列表 
     * - 2: 获取已结束的列表
     */
    BidsTabs(val) {
      this.bidsTabs = val;
      this.pi = 1;
      this.ps = 60;
      this.Sort = '1';
      this.list='';
      if (val == 0) {
        this.listType = "bids";
        this.onsale = 1;
        this.getBids();
      }
      if (val == 1) {
        this.listType = "offers";
        this.Sort = '2';
        this.getOffer()
      }
      if (val == 2) {
        this.listType = "bids";
        this.onsale = 2;
        this.Sort = '3';
        this.getBids()
      }
    },
    /**
     * 根据列表类型切换数据获取方法
     * 当列表类型为 'bids' 时获取竞价列表
     * 当列表类型为 'offers' 时获取报价列表
     */
    bidsSort() {
      if (this.listType == "bids") {
        this.getBids()
      } else if (this.listType == "offers") {
        this.getOffer()
      }
    },
    offerStatus() {
      this.getOffer()
    },
    updatedWatch(val) {
      this.getBids()
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      if(this.listType=='bids'){
        this.getBids();
      }else{
        this.getOffer()
      }
      //this.getBids();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      if(this.listType=='bids'){
        this.getBids();
      }else{
        this.getOffer()
      }
      //this.getBids();
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";
.flex_layout_bids{
    line-height: 48px;
    padding: 0;
    height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/bids.vue